export enum CancellationStatus {
  Valid = "VALID",
  AlreadyAccepted = "ALREADY_ACCEPTED",
  Expired = "EXPIRED",
}

export enum CancellationView {
  Request = "REQUEST",
  AlreadyConfirmed = "ALREADY_CONFIRMED",
  Expired = "EXPIRED",
  Error = "ERROR",
}

export enum CancellationRefundType {
  FullRefund = "FULL_REFUND",
  RefundWithPenalty = "REFUND_WITH_PENALTY",
  NonRefundable = "NON_REFUNDABLE",
}
